import { usePdfData } from '@hcs/pdf/pdf-service';
import { PropertyStateListing } from '@hcs/types';

export const useMlsListingSheetData = () => {
  return usePdfData<PropertyStateListing>();
};
